import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Pagination, // Import Pagination component
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import PageLoading from "../../../../components/Loading/PageLoading";
import Grid from "@mui/material/Grid2";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLoading } from "../../../../context/LodingContext";
import BASEURL from "../../../../pages/Utils/Baseurl";
import request from "graphql-request";
import RefreshIcon from "@mui/icons-material/Refresh";
import { downloadExcelFile } from "../../../function/downloadExcel";
import {
  allCustomers,
  allProducts,
  allUsers,
  exportProductMaster,
  exportSalesOrder,
  SalesOrderFilter,
  todayCustomersDropdown,
} from "../ReportData";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../ReportStateMange";
import OptionConvert from "../../../components/OptionConvert";
import Swal from "sweetalert2";
import { allsalesorders } from "../../salesOrder/salesOrderData/salesOrderData";
import URL from "../../../../pages/Utils/url";
import ReusableFilter from "../../../components/ReusableFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReportDefaultUi from "../reportDefaultui";

function SalesOrder() {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [salesOrderData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState
  );
  const [isTabel, setIsTabel] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [datas, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [customerOptions, setCustomerOptions] = useState([
    { label: "All", value: "All" },
  ]);

  // Pagination state for graph view
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Display 5 items per page in the graph

  useEffect(() => {
    fetchCustomer();
    // fetchProductName();
    fetchAgentName();
    // fetchFilteredStock();
    setIsTabel(false);
  }, []);

  const SalesOrderTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Sale Order ID",
        field: "soNumber",
        name: "soNumber",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Customer Name",
        field: "customerName",
        name: "customerName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },

      {
        headerName: "Total Amount",
        field: "totalAmount",
        name: "totalAmount",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Approval Status",
        field: "status",
        name: "status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: datas?.map((v, i) => ({
      sno: i + 1,
      id: i + 1,
      soNumber: v.orderSio,
      customerName: v.customerName,
      orderDate: v.orderDate,
      totalAmount: v?.totalAmount || v?.products[0]?.amount,
      status: v.status || "N/A",
      Action: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "20px",
            alignItems: "center",
          }}
        >
          <VisibilityIcon
            style={{
              color: "GrayText",
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(`/sales-order-report/view-sales-order`, {
                state: { type: "view", data: v },
              })
            }
          />
        </div>
      ),
    })),
  };

  //download excel file
  const handleDownload = () => {
    const customers =
      salesOrderData?.customerName?.length > 0
        ? salesOrderData?.customerName?.map((item) => item.label) || []
        : [];
    const agents =
      salesOrderData?.agentName?.length > 0
        ? salesOrderData?.agentName?.map((item) => item.label) || []
        : [];
    const status = salesOrderData?.approval?.value
      ? [salesOrderData?.approval?.value]
      : [];
    const products =
      salesOrderData?.productName?.length > 0
        ? salesOrderData?.productName?.map((item) => item.label) || []
        : [];

    setCirleLoading(true);
    request(BASEURL, exportSalesOrder, {
      startDate: salesOrderData?.fromDate,
      endDate: salesOrderData?.toDate,
      products,
      customers,
      status,
      agents,
    })
      .then(async (res) => {
        const status = res?.exportSalesOrderReport?.success;

        const pdfurl = `${URL}${res?.exportSalesOrderReport?.fileUrl?.slice(
          1
        )}`;

        if (status) {
          await downloadExcelFile(pdfurl, "sales_order_report.xlsx");
          setCirleLoading(false);
        }
      })
      .catch((err) => {
        setCirleLoading(false);
        Swal.fire({
          position: "top",
          icon: "error",
          title: "Failed to download file.",
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  //get customer option
  const fetchCustomer = () => {
    request(BASEURL, todayCustomersDropdown)
      .then((res) => {
        const customerName = OptionConvert(
          res?.todayCustomersDropdown?.data,
          "customerName",
          "id"
        );
        setCustomerOptions((prevOptions) => [...prevOptions, ...customerName]);
      })
      .finally(() => {});
  };

  // //get product name option
  // const fetchProductName = () => {
  //   setIsLoading(true);
  //   request(BASEURL, allProducts)
  //     .then((res) => {
  //       // const productName = OptionConvert(
  //       //   res?.allProducts?.data,
  //       //   "productName",
  //       //   "id"
  //       // );
  //       // setProductNameOptions((prevOptions) => [
  //       //   ...prevOptions,
  //       //   ...productName,
  //       // ]);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  //get agent name option
  const fetchAgentName = () => {
    request(BASEURL, allUsers)
      .then((res) => {
        const agentName = OptionConvert(res?.allUsers, "employeeName", "id");
        setAgentOptions((prevOptions) => [...prevOptions, ...agentName]);
      })
      .finally(() => {});
  };

  //get SalesOrderData table data
  // const fetchSalesOrderData = () => {
  //   setIsLoading(true);
  //   request(BASEURL, allsalesorders)
  //     .then((res) => {
  //       const newdata = res?.allsalesorders?.data;
  //       const data = newdata?.map((v, i) => ({
  //         sno: i + 1,
  //         id: i + 1,
  //         soNumber: v.soNumber,
  //         customerName: v.customer?.customerName,
  //         orderDate: v.orderDate,
  //         totalAmount: v.totalAmount || v?.salesorderproductSet[0]?.totalAmount,
  //         status: v.status || "N/A",
  //         createdBy: v?.user?.employeeName,
  //         Action: (
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "space-evenly",
  //               marginTop: "20px",
  //               alignItems: "center",
  //             }}
  //           >
  //             <VisibilityIcon
  //               style={{
  //                 color: "GrayText",
  //                 fontSize: "20px",
  //                 cursor: "pointer",
  //               }}
  //               onClick={() =>
  //                 navigate(`/sales-order-report/view-sales-order`, {
  //                   state: { type: "view", data: v },
  //                 })
  //               }
  //             />
  //           </div>
  //         ),
  //       }));
  //       setData(data);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  const resetFilters = () => {
    dispatch({ name: "reset" });
    setData([]);
    setIsTabel(false);
    setIsLoading(false);
    setCurrentPage(1);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrentPage(1); // Reset pagination when switching tabs
  };

  // Pagination for graph view
  const totalPages = Math.ceil(datas.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentGraphData = datas.slice(startIndex, endIndex);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const submitFilter = (data) => {
    const agentName =
      salesOrderData?.agentName?.length > 0
        ? salesOrderData?.agentName.map((item) => item.label)
        : [];
    const customerName =
      salesOrderData?.customerName?.length > 0
        ? salesOrderData?.customerName.map((item) => item.label)
        : [];

    fetchFilteredStock(
      salesOrderData.fromDate,
      salesOrderData.toDate,
      agentName,
      customerName,
      salesOrderData?.approval?.value ? [salesOrderData?.approval?.value] : [] // Pass approval status as array
    );
  };

  //filter api call
  const fetchFilteredStock = (
    startDate,
    endDate,
    agents,
    customers,
    statuses
  ) => {
    setIsLoading(true);
    setIsTabel(true);

    const payload = {
      startDate: startDate || null,
      endDate: endDate || null,
      customers: customers || [],
      agents: agents || [],
      status: statuses || [],
    };

    request(BASEURL, SalesOrderFilter, payload)
      .then((res) => {
        const newdata = res?.salesOrderReport?.data;
        setData(newdata);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
        setIsTabel(true);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Sales Order Report
                </MaterialTypography>
              </Stack>
              {salesOrderData?.fromDate && salesOrderData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={handleDownload}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />
        {/* tabs */}
        <Box sx={{ my: "5px" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#2a9941",
                    color: "white",
                  },
                }}
                centered
              >
                <Tab label="Table list view" />
                <Tab label="Graph view" />
              </Tabs>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                bgcolor: "background.paper",
              }}
            >
              <IconButton
                onClick={() => setDialogOpen(true)}
                aria-label="Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <FilterListIcon fontSize="large" />
              </IconButton>
              <IconButton
                onClick={resetFilters}
                aria-label="Reset Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <RefreshIcon fontSize="large" />
              </IconButton>
            </Box>
          </Stack>
        </Box>
        {/* filter fields */}
        <ReusableFilter
          data={salesOrderData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              salesOrderData,
            })
          }
          title="Sales Order Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={salesOrderData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Approval Status
              </MaterialTypography>
            </MaterialBox>
            <MaterialSelect
              name="approval"
              value={salesOrderData?.approval}
              customStyles={{ optionPadding: 20 }}
              options={[
                { label: "All", value: "All" },
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              onChange={(e, s) => dispatch({ value: e, name: s?.name })}
              isClearable
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Customer Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={customerOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={salesOrderData?.customerName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "customerName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>

        {!isTabel && <ReportDefaultUi setOpen={setDialogOpen} />}
        {!isLoading && isTabel && (
          <>
            {value === 0 ? (
              //Table list view
              <Box>
                {!isLoading && (
                  <MaterialDataGrid
                    rows={SalesOrderTable?.rows}
                    columns={SalesOrderTable?.columns}
                    isSelectable={false}
                    localeText={{
                      noRowsLabel: (
                        <Stack
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <MaterialTypography
                            variant="body2"
                            fontWeight="medium"
                            color="text"
                          >
                            No Sales Order Data Found
                          </MaterialTypography>

                          <MaterialTypography variant="caption" color="text">
                            Try adjusting or clearing your filters to see Sales
                            Order data.
                          </MaterialTypography>
                        </Stack>
                      ),
                    }}
                  />
                )}
              </Box>
            ) : (
              //graph list view
              <>
                <ResponsiveContainer width="100%" height={450}>
                  <BarChart
                    data={currentGraphData} // Use sliced data for the current page
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    barSize={30}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="orderSio"
                      tick={{ fontSize: 12 }} // ⬅ smaller text
                      tickMargin={8}
                    />
                    <YAxis
                      tick={{ fontSize: 12 }} // ⬅ smaller text
                      tickMargin={8}
                    />
                    <Tooltip
                      contentStyle={{
                        fontSize: "12px",
                        borderRadius: "8px",
                        background: "rgba(255, 255, 255, 0.8)",
                        border: "1px solid #ccc",
                        padding: "2px",
                      }}
                      wrapperStyle={{
                        outline: "none",
                      }}
                    />
                    <Legend wrapperStyle={{ fontSize: "12px" }} />
                    <Bar
                      dataKey="totalAmount"
                      fill="#8884d8"
                      name="Total Amount"
                    />
                  </BarChart>
                </ResponsiveContainer>
                <Box display="flex" justifyContent="center" mt={2} mb={2}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Box>
              </>
            )}
          </>
        )}
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
}
export default SalesOrder;
